import React from 'react'
import _cx from 'classnames/bind'
import { Ribbon, constants } from '@adc/ui-adc'
import cls from './styles.scss'
_cx.bind(cls)

interface RightRibbonProps {
  text: string
  color: constants.ColorNames
}

const RightRibbon = ({
  text,
  color = constants.ColorNames.Success,
}: RightRibbonProps) => (
  <Ribbon
    id='right-ribbon'
    color={color}
    ribbon='right'
    data-elm-id='right_ribbon'
  >
    {text}
  </Ribbon>
)

export default RightRibbon
